const API_ENDPOINTS = {
  // 관리자 프로필 API
  USERS_PROFILE: 'users/profile',

  // 파일 API
  FILE_UPLOAD_TEMP: '/file/upload/temp',
  FILE_UPLOAD_PRESIGN: '/file/upload/presign',
  FILE_UPLOAD_COMPLETE: '/file/upload/complete',
  FILE_CKEDITOR_UPLOAD: '/file/ckeditor/upload',

  // 게시판 API
  BOARDS: '/boards',
  BOARDS_INFO: '/boards/',
  BOARDS_IDCHECK: '/boards/idcheck/',

  // 게시글 API
  BOARD_CONTENTS: '/board-contents',
  NOTICE_CONTENTS: '/board-contents/notice',

  // 구글 Geocoding API (위도, 경도)
  GEOCODING: '/api/geocoding',

  // 팝업 API
  POPUP: '/popup',

  // 배너 API
  BANNER: '/banner/',

  // 배너아이템 API
  BANNER_ITEM: '/banner-item',

  // 유저(관리자) API
  ADMIN_USERS: 'admin/users',
  ADMIN_USERS_DETAIL: 'admin/users/',
  ADMIN_USERS_LOGIN: 'admin/users/login',
  ADMIN_USERS_EXCEL: 'admin/users/excel',

  // 탈퇴 회원(관리자) API
  ADMIN_USER_LEAVE: 'admin/user-leave',

  // 게시글(관리자) API
  ADMIN_BOARD_CONTENTS: '/admin/board-contents',
  ADMIN_BOARD_CONTENTS_DETAIL: '/admin/board-contents/',
  ADMIN_BOARD_CONTENTS_STATUS_CHANGE: '/admin/board-contents/status-change',
  ADMIN_BOARD_CONTENTS_TYPE_CHANGE: '/admin/board-contents/type-change',

  // 메시지(관리자) API
  ADMIN_MESSAGE: '/admin/message',
  ADMIN_MESSAGE_TEMPLATE: '/admin/message/',

  // 이메일(관리자) API
  ADMIN_EMAIL: '/admin/email',
  ADMIN_EMAIL_UPDATE: '/admin/email/',

  // 설정관련 API
  SETTINGS: '/settings',

  // 팝업(관리자) API
  ADMIN_POPUP: '/admin/popup',
  ADMIN_POPUP_DETAIL: '/admin/popup/',

  // 관리자 데이터 테이블 순서정렬 API
  ADMIN_SORTING: '/admin/sorting',

  // 댓글 API
  COMMENT: '/comment',
  COMMENT_LIST: '/comment/',
  COMMENT_UPDATE: '/comment/',
  COMMENT_DELETE: '/comment/',
};

export default API_ENDPOINTS;
